import React, { useState, useEffect, useRef } from "react";
import { OnfidoView } from "./onFidoView";
import { Onfido } from "onfido-sdk-ui";
import { X } from "lucide-react";
import ConfirmationDialog from "./confirmation-dialog";

const IDScanModal = ({
  isOpen,
  onClose,
  sessionUrl,
  onFidoData,
  isResumeOnfidoFlow,
  user,
  createMessage,
  addMessage,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const iframeRef = useRef(null);

  // Reset loading state when modal opens
  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      setShowConfirmation(false); // Reset confirmation state when modal opens
    }
  }, [isOpen]);

  // Handle body scroll locking
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  // Handle iframe load
  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  // Handle close button click - show confirmation first
  const handleCloseClick = () => {
    setShowConfirmation(true);
  };

  // Handle confirmation dialog - user confirms close
  const handleConfirmClose = () => {
    setShowConfirmation(false);
    onClose();
  };

  // Handle confirmation dialog - user cancels close
  const handleCancelClose = () => {
    setShowConfirmation(false);
  };

  // Handle direct close (called from OnfidoView component)
  const handleDirectClose = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl h-[90vh] flex flex-col relative">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-1 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900"></h2>
          <button
            onClick={handleCloseClick}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Close modal"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Modal Content */}
        <div className="flex-1 relative">
          {/* {isLoading && (
            <div className="absolute inset-0 bg-gray-50 flex items-center justify-center z-10">
              <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
                <p className="text-gray-600">Loading verification session...</p>
              </div>
            </div>
          )} */}
          {/* <iframe
            ref={iframeRef}
            src={sessionUrl}
            className="w-full h-full border-0"
            onLoad={handleIframeLoad}
            allow="camera; microphone; geolocation"
            title="Identity Verification"
          /> */}
          <OnfidoView
            data={onFidoData}
            setIsLoading={setIsLoading}
            isResumeOnfidoFlow={isResumeOnfidoFlow}
            user={user}
            createMessage={createMessage}
            addMessage={addMessage}
            handleClose={handleDirectClose}
          />
        </div>

        {/* Modal Footer */}
        {/* <div className="p-2 border-t border-gray-200 bg-gray-50">
          <div className="flex items-center justify-between">
            <p className="text-sm text-gray-600">
              Please complete all verification steps before closing this window.
            </p>
            <button
              onClick={handleClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
            >
              Close
            </button>
          </div>
        </div> */}

        {/* Confirmation Dialog */}
        <ConfirmationDialog
          isOpen={showConfirmation}
          onConfirm={handleConfirmClose}
          onCancel={handleCancelClose}
          heading={"Close Verification?"}
          subHeading={"Are you sure you want to close the identity verification? Your progress will be saved and you can continue later."}
        />
      </div>
    </div>
  );
};

export default IDScanModal;
